// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>27</span>&nbsp;&nbsp;Though they curse, may you bless;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let those who rise up against me be confounded,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;but let your servant rejoice.<br> </p> </div></div>";
// Exports
module.exports = code;